import yup from "./yup";

const adminUserDeleteSchema = yup.object().shape({});

export { adminUserDeleteSchema };
